import React from "react";
import { Box, Typography, Select, MenuItem } from "@mui/material";

function humanizeLabel(key) {
  if (!key) return "";
  return key
    .toString()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function FieldSelect({ name, schema = {}, value, onChange }) {
  const description = schema.description;
  const options = Array.isArray(schema.options) ? schema.options : [];
  const current = value === undefined || value === null ? "" : value;

  const handleChange = (e) => {
    const v = e.target.value;
    if (v === "") {
      if (onChange) onChange(undefined); // allow clearing
    } else {
      if (onChange) onChange(v);
    }
  };

  return (
    <Box mb={1} sx={{ maxWidth: 360 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {humanizeLabel(name)}:
        </Typography>
        <Select
          value={current}
          onChange={handleChange}
          size="small"
          displayEmpty
          sx={{ height: 42 }}
          inputProps={{ "aria-label": humanizeLabel(name) }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {options.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {humanizeLabel(opt)}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
}
